module.exports = __webpack_public_path__ + "img/qualityIndexScore.e8d8a779.png";